import { Link } from "react-router-dom";
import CaseTakingPanel from "@/components/CaseTakingPanel";
import { ChevronLeft, ClipboardList } from "lucide-react";
import PinGate from "@/components/PinGate";

/** Standalone Homoeopathy Case-Taking page — no birth profile required. */
export default function CaseTakingPage() {
  return (
    <div className="min-h-screen bg-[#0F1115] text-[#E6E1D6]">
      <div className="grain-overlay pointer-events-none fixed inset-0 z-0" />

      <header className="relative z-10 border-b border-[#2A2D35] bg-[#0F1115]/90 backdrop-blur-md sticky top-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between gap-3">
          <Link to="/" data-testid="case-back-link"
                className="flex items-center gap-2 text-[#A19E95] hover:text-[#D4AF37] transition-colors">
            <ChevronLeft size={18} />
            <div>
              <div className="text-[9px] uppercase tracking-[0.4em] text-[#6E6B64] font-mono">
                Back to · Jyotish · Homeopathy
              </div>
              <div className="font-heading text-base sm:text-lg">Insight Engine</div>
            </div>
          </Link>
          <div className="text-right shrink-0">
            <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.4em] text-[#D4AF37] font-mono flex items-center gap-2 justify-end">
              <ClipboardList size={12} /> Homoeopathy Case-Taking
            </div>
            <div className="text-[9px] text-[#A8896C] font-mono tracking-widest mt-0.5">
              Adult Case Record · Sankaran Format
            </div>
          </div>
        </div>
      </header>

      <PinGate subtitle="Enter Case-Taking PIN">
        <main className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
          <div className="mb-6">
            <div className="text-xs uppercase tracking-widest text-[#D4AF37] font-mono">Standalone · Independent of any Birth Profile</div>
            <div className="font-heading text-3xl sm:text-4xl text-[#E6E1D6] mt-1">Homoeopathy Case-Taking</div>
            <div className="font-mono text-xs text-[#6E6B64] mt-2 max-w-2xl">
              11-section Sankaran-style adult case record with dynamic complaint entries.
              Save multiple cases and download a clean case-record PDF for any of them.
            </div>
          </div>
          <CaseTakingPanel />
        </main>
      </PinGate>
    </div>
  );
}
